import React from 'react';
import PropTypes from 'prop-types';

import { cls } from '@mssgme/helpers';
import { useRenderer } from '../../hooks';
import BuyButton from './BuyButton';

import styles from './ServiceContent.scss';

export const ServiceActionsPane = ({
    contacts,
    service,
    interactive,
    enabledPayments,
    onCartAdd,
    currency,
    ...rest
}) => {
    const renderBlock = useRenderer();

    return (
        <div {...cls(styles.contacts, rest)}>
            {enabledPayments && (
                <div className={styles.actionsBuy} style={{ marginBottom: contacts?.length ? 0 : 12 }}>
                    <BuyButton
                        service={service}
                        productCurrency={currency}
                        interactive={interactive}
                        onCartAdd={onCartAdd}
                    />
                </div>
            )}

            {contacts?.length > 0 && contacts.map(renderBlock)}
        </div>
    );
};

ServiceActionsPane.propTypes = {
    contacts: PropTypes.arrayOf(PropTypes.shape({})),
    service: PropTypes.object.isRequired,
    interactive: PropTypes.bool,
    enabledPayments: PropTypes.bool,
    onCartAdd: PropTypes.func.isRequired,
    currency: PropTypes.string,
};
